// Amplify's pool configuration is global. Keep each session read, including
// its attributes and refreshed tokens, together before another pool is probed.
let pending = Promise.resolve();

export const withSessionLock = (operation) => {
  const result = pending.then(operation);
  pending = result.catch(() => {});
  return result;
};
